import { useParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import ProductsTable from "./ProductsTable";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { useAuth } from "../../contexts/AuthContext";

export default function AdminCategoryProducts() {
  const { categoryId } = useParams();
  const { auth } = useAuth();

  const [products, setProducts] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);

  const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;

  const fetchProducts = useCallback(async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${PRODUCT_API}/products/admin`, {
        params: {
          categoryId,
          page: 0,
          size: 50,
        },
      });

      setProducts(res.data?.content || []);
      setCategoryName(res.data?.content?.[0]?.category?.name || "Category");
    } catch (err) {
      console.error("Failed to load products", err);
    } finally {
      setLoading(false);
    }
  }, [categoryId, PRODUCT_API]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  /* Approve */
  const handleApprove = async (id) => {
    try {
      await axios.put(`${PRODUCT_API}/products/${id}/moderate`, {
        adminId: auth.userId,
        status: "APPROVED",
        reason: null,
      });
      fetchProducts();
    } catch (err) {
      console.error("Approve failed", err);
    }
  };

  /* Reject */
  const handleReject = async (id, reason) => {
    try {
      await axios.put(`${PRODUCT_API}/products/${id}/moderate`, {
        adminId: auth.userId,
        status: "REJECTED",
        reason,
      });
      fetchProducts();
    } catch (err) {
      console.error("Reject failed", err);
    }
  };

  if (loading) return <Spinner text="Loading products..." />;

  return (
    <div className="container-fluid">
      {/* Page Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 className="fw-bold mb-0">{categoryName} Products</h3>
          <small className="text-muted">Moderation panel</small>
        </div>

        <span className="badge bg-primary">{products.length} Products</span>
      </div>

      {/* Products Table */}
      <ProductsTable
        products={products}
        onApprove={handleApprove}
        onReject={handleReject}
      />
    </div>
  );
}
